import React from "react";
//  id => Correspondiente al nombre del componente en BD
//  Component => Componente a renderizar
const CatalogCMIRoutes = [
    {
        Id: "CUADRO_MANDO_ADMINISTRACION",
        Component: React.lazy(() => import("../pages/Scorecard/IndexScoreCard")),
    },
    {
        Id: "CUADRO_MANDO_ADMIN_CALENDARIOS",
        Component: React.lazy(() => import("../pages/Calendar/Calendario")),
    },
    {
        Id: "CUADRO_MANDO_ADMIN_OBJETIVOS",
        Component: React.lazy(() => import("../pages/Objectives/Objetives")),
    },    
    { 
        Id: "CUADRO_MANDO_ADMIN_USUARIOS",
        Component: React.lazy(() => import("../pages/UserManagement/Index")),
    },
];

export default CatalogCMIRoutes;